import React, { useState } from "react";


import {
  FaSeedling,
  FaChevronDown,
  FaChevronUp,
  FaCheck,
} from "react-icons/fa";

const RESPONSIVE_CSS = `
  .agp-hero-inner {
    width: 92% !important;
    padding: 38px 0px !important;
  }
  .agp-hero-icon {
    width: 44px !important;
    height: 44px !important;
  }
  .agp-hero-title {
    font-size: clamp(22px, 5vw, 34px) !important;
  }
  .agp-hero-desc {
    font-size: clamp(13px, 2vw, 15px) !important;
    line-height: 1.8 !important;
  }
  .agp-accordion-wrap {
    width: 92% !important;
    padding: 28px 0px 50px !important;
  }
  .agp-accordion-header {
    padding: 14px 16px !important;
    gap: 10px !important;
  }
  .agp-accordion-title {
    font-size: 15px !important;
  }
  .agp-accordion-content {
    padding: 16px 18px !important;
  }
  .agp-point-text {
    font-size: 14px !important;
  }

  @media (max-width: 600px) {
    .agp-hero-inner {
      width: 90% !important;
      padding: 28px 0px !important;
    }
    .agp-hero-row {
      gap: 10px !important;
      margin-bottom: 12px !important;
    }
    .agp-hero-icon {
      width: 38px !important;
      height: 38px !important;
      border-radius: 8px !important;
    }
    .agp-hero-icon svg {
      font-size: 17px !important;
    }
    .agp-hero-title {
      font-size: clamp(19px, 6vw, 26px) !important;
    }
    .agp-hero-desc {
      font-size: 13px !important;
      line-height: 1.7 !important;
    }
    .agp-accordion-wrap {
      width: 92% !important;
      padding: 20px 0px 36px !important;
    }
    .agp-accordion-header {
      padding: 12px 14px !important;
    }
    .agp-accordion-title {
      font-size: 14px !important;
      line-height: 1.4 !important;
    }
    .agp-accordion-content {
      padding: 14px 14px !important;
    }
    .agp-point-row {
      gap: 10px !important;
      margin-bottom: 10px !important;
    }
    .agp-point-check {
      width: 20px !important;
      height: 20px !important;
      min-width: 20px !important;
    }
    .agp-point-check svg {
      font-size: 9px !important;
    }
    .agp-point-text {
      font-size: 13px !important;
      line-height: 1.6 !important;
    }
  }

  @media (max-width: 360px) {
    .agp-hero-title {
      font-size: 18px !important;
    }
    .agp-accordion-title {
      font-size: 13px !important;
    }
  }
`;

function AgricultureAgritechPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const sections = [
    {
      title: "Crop Management",
      points: [
        "Crop Disease Detection Agent",
        "Precision Irrigation Agent",
        "Fertilizer Optimization Agent",
        "Pest Identification & Alert Agent",
        "Yield Prediction Agent",
      ],
    },

    {
      title: "Equipment & Machinery",
      points: [
        "Smart Tractor Navigation Agent",
        "Drone Spraying Route Agent",
        "Maintenance Scheduling Agent for Equipment",
        "Machinery Efficiency Monitoring Agent",
        "Fuel Optimization Agent",
      ],
    },

    {
      title: "Farm Operations",
      points: [
        "Farm Budget Optimization Agent",
        "Farm Activity Log Agent",
        "Daily Farm Task Scheduling Agent",
        "Risk Management & Insurance Agent",
        "Smart Greenhouse Automation Agent",
      ],
    },

    {
      title: "Agritech Research",
      points: [
        "Seed Variant Performance Predictor Agent",
        "Genomic Breeding Recommender Agent",
        "Soil Microbiome Pattern Agent",
        "Weather-Impact Simulation Agent",
        "Fertilizer-Soil Interaction Agent",
      ],
    },

    {
      title: "Post-Harvest & Supply Chain",
      points: [
        "Harvest Logistics Agent",
        "Cold Storage Optimization Agent",
        "Quality Grading Agent (Vision-based)",
        "Export Readiness Agent",
        "Traceability Agent",
      ],
    },
  ];

  return (
    <>
      <style>{RESPONSIVE_CSS}</style>

      <div
        style={{
          background: "#22c7b8",
          minHeight: "100vh",
          overflowX: "hidden",
        }}
      >
        {/* HERO SECTION */}
        <div
          style={{
            background: "#173b8f",
            width: "100%",
          }}
        >
          <div
            className="agp-hero-inner"
            style={{
              width: "92%",
              maxWidth: "1300px",
              margin: "0 auto",
              padding: "38px 0px",
              boxSizing: "border-box",
            }}
          >
            <div
              className="agp-hero-row"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                marginBottom: "16px",
                flexWrap: "wrap",
              }}
            >
              <div
                className="agp-hero-icon"
                style={{
                  width: "44px",
                  height: "44px",
                  background: "#22c7b8",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <FaSeedling
                  style={{
                    color: "#ffffff",
                    fontSize: "20px",
                  }}
                />
              </div>

              <h1
                className="agp-hero-title"
                style={{
                  color: "#ffffff",
                  fontSize: "34px",
                  fontWeight: "700",
                  margin: 0,
                  fontFamily: "Exo, sans-serif",
                  wordBreak: "break-word",
                }}
              >
                Agriculture & Agritech
              </h1>
            </div>

            <p
              className="agp-hero-desc"
              style={{
                color: "#f2f2f2",
                fontSize: "15px",
                lineHeight: "1.9",
                maxWidth: "1000px",
                margin: 0,
              }}
            >
              Agriculture involves crop cultivation, livestock
              management, and food production. AI agents help with
              precision farming, pest detection, irrigation control,
              yield prediction, and supply chain optimization—
              boosting productivity and sustainability.
            </p>
          </div>
        </div>

        {/* ACCORDION SECTION */}
        <div
          className="agp-accordion-wrap"
          style={{
            width: "78%",
            maxWidth: "1050px",
            margin: "0 auto",
            padding: "28px 0px 50px",
            boxSizing: "border-box",
          }}
        >
          {sections.map((section, index) => (
            <div
              key={index}
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                marginBottom: "10px",
                overflow: "hidden",
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              }}
            >
              {/* HEADER */}
              <div
                onClick={() => toggle(index)}
                className="agp-accordion-header"
                style={{
                  padding: "14px 18px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  cursor: "pointer",
                  background:
                    openIndex === index
                      ? "#173b8f"
                      : "#ffffff",
                  transition: "0.3s",
                  gap: "12px",
                  boxSizing: "border-box",
                }}
              >
                <h2
                  className="agp-accordion-title"
                  style={{
                    margin: 0,
                    fontSize: "16px",
                    fontWeight: "700",
                    color:
                      openIndex === index
                        ? "#ffffff"
                        : "#173b8f",
                    fontFamily: "Exo, sans-serif",
                    wordBreak: "break-word",
                    minWidth: 0,
                  }}
                >
                  {section.title}
                </h2>

                {openIndex === index ? (
                  <FaChevronUp
                    style={{
                      color: "#ffffff",
                      fontSize: "16px",
                      flexShrink: 0,
                    }}
                  />
                ) : (
                  <FaChevronDown
                    style={{
                      color: "#173b8f",
                      fontSize: "16px",
                      flexShrink: 0,
                    }}
                  />
                )}
              </div>

              {/* CONTENT */}
              {openIndex === index && (
                <div
                  className="agp-accordion-content"
                  style={{
                    padding: "18px 24px",
                    background: "#ffffff",
                    boxSizing: "border-box",
                  }}
                >
                  {section.points.map((point, i) => (
                    <div
                      key={i}
                      className="agp-point-row"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        marginBottom: "12px",
                      }}
                    >
                      <div
                        className="agp-point-check"
                        style={{
                          width: "24px",
                          height: "24px",
                          minWidth: "24px",
                          borderRadius: "50%",
                          background: "#22c7b8",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FaCheck
                          style={{
                            color: "#ffffff",
                            fontSize: "10px",
                          }}
                        />
                      </div>

                      <p
                        className="agp-point-text"
                        style={{
                          margin: 0,
                          color: "#4b5563",
                          fontSize: "15px",
                          lineHeight: "1.7",
                          fontWeight: "500",
                          wordBreak: "break-word",
                        }}
                      >
                        {point}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default AgricultureAgritechPage;
